<template>
  <div >
    <a-layout style="background-color: white">

      <a-breadcrumb style="padding: 16px 24px">
        <a-breadcrumb-item>
          <router-link :to="{name:'scf'}">
            <a-icon type="home" />
            <span>首页</span>
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item href="">
          <router-link :to="{name:'activity'}">
            <span>活动</span>
          </router-link>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <a-layout-content>
        <a-layout>
          <a-layout-sider
            width="120"
            breakpoint="lg"
            collapsed-width="0"
            @collapse="onCollapse"
            @breakpoint="onBreakpoint"
            theme="light"
          >
            <a-menu theme="light" mode="inline" :default-selected-keys="['0']"
                    @click="filterActivities"
            >
              <a-menu-item key="0">
                <span class="nav-text">全部</span>
              </a-menu-item>
              <template v-for="item in categories">
                <a-menu-item :key="item.id">
                  <span class="nav-text">{{item.name}}</span>
                </a-menu-item>
              </template>


            </a-menu>
          </a-layout-sider>
          <a-layout-content>
            <div :style="{ padding: '24px',paddingTop:0, background: '#fff', minHeight: '360px' }">

              <a-list item-layout="vertical" :data-source="activities">
                <a-list-item slot="renderItem" key="item.title" slot-scope="item, index">

                  <a-list-item-meta>
                    <a slot="title" class="text-title">{{ item.name }}</a>
                  </a-list-item-meta>
                  <div style="max-height:60px;" class="overflow-ellipsis"> {{ item.brief }}</div>
                  <template>
                    <div style="margin-top:12px; text-align: right">
                      <router-link :to="{name:'activityInfo', params:{id:item.id}}" style="color:var(--primaryColor); margin:20px 20px 0 0;">查看详情 <a-icon type="double-right"></a-icon></router-link>
                    </div>
                  </template>

                </a-list-item>
              </a-list>

              <div>


                <a-pagination
                  show-quick-jumper
                  :default-current="page"
                  :total="count"
                  :page-size="3"
                  :show-total="total => `共 ${total} 条`"
                  show-less-items
                  @change="pageChange"
                />
              </div>




            </div>
          </a-layout-content>

        </a-layout>


      </a-layout-content>

    </a-layout>



  </div>
</template>

<script>
import {getActivityCategory, getActivityList} from "../../api/api";
import {filterUnderLine} from "../../../static/js/util";


export default {
  name: "ActivityList",
  data() {
    return {
      activities:[],
      categories:[],
      page:1,
      search:'',
      category:'',
      count :0
    };
  },
  mounted() {

    this.toGetActivities()
    getActivityCategory()
    .then(res=>{
      this.categories = filterUnderLine(res.data)
    })
    .catch(err=>{
      console.log(err)
    })



  },
  methods: {
    pageChange(pageNumber){
      this.page=pageNumber
      this.toGetActivities(this.page, this.search, this.category)
    },
    toGetActivities(page, search, filter){
      getActivityList({page:page, 'category__id' :filter, search:search})
        .then(res => {
        this.activities = filterUnderLine(res.data.results)
        this.count = res.data.count

      }).catch((err) => {
        console.log(err)
      })},
    onCollapse(collapsed, type) {
    },
    onBreakpoint(broken) {
    },
    filterActivities(item, key, keyPath) {
      this.category =  item.key!=='0' ?item.key:''
      this.page=1
      this.toGetActivities(this.page, this.search, this.category)

    }
  },
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/content/ActivityList.vue